import { includes } from 'lodash';
import { PaginationType } from './pagination';
import { SECTION_CATEGORY, SECTION_HOMEPAGE, SECTION_MY_POSTS, SECTION_POST_LIST, SECTION_RELATED_POSTS, } from './sections';
export var Layout;
(function (Layout) {
    Layout[Layout["CardProfile"] = 3] = "CardProfile";
    Layout[Layout["FullPost"] = 4] = "FullPost";
    Layout[Layout["Mobile"] = 5] = "Mobile";
    Layout[Layout["OneColumnMobile"] = 10] = "OneColumnMobile";
    Layout[Layout["SideBySideMobile"] = 11] = "SideBySideMobile";
    Layout[Layout["TextOnImageMobile"] = 12] = "TextOnImageMobile";
    Layout[Layout["PgTextOnImageSmall"] = 23] = "PgTextOnImageSmall";
    Layout[Layout["PgTextOnImageMedium"] = 13] = "PgTextOnImageMedium";
    Layout[Layout["PgTextOnImageLarge"] = 24] = "PgTextOnImageLarge";
    Layout[Layout["PgCardMedium"] = 14] = "PgCardMedium";
    Layout[Layout["PgSideBySide"] = 15] = "PgSideBySide";
    Layout[Layout["PgSideBySideRight"] = 22] = "PgSideBySideRight";
    Layout[Layout["PgGrid"] = 16] = "PgGrid";
    Layout[Layout["PgGridIntermediate"] = 20] = "PgGridIntermediate";
    Layout[Layout["PgGridLarge"] = 21] = "PgGridLarge";
    Layout[Layout["PgOneColumn"] = 17] = "PgOneColumn";
    Layout[Layout["Slider"] = 18] = "Slider";
    Layout[Layout["List"] = 19] = "List";
    Layout[Layout["ListMedium"] = 25] = "ListMedium";
    Layout[Layout["ListLarge"] = 26] = "ListLarge";
    /** @deprecated Legacy */
    Layout[Layout["CardSmall"] = 0] = "CardSmall";
    /** @deprecated Legacy */
    Layout[Layout["CardMedium"] = 1] = "CardMedium";
    /** @deprecated Legacy */
    Layout[Layout["CardLarge"] = 2] = "CardLarge";
    /** @deprecated Legacy */
    Layout[Layout["SideBySide"] = 6] = "SideBySide";
    /** @deprecated Legacy */
    Layout[Layout["Grid"] = 7] = "Grid";
    /** @deprecated Legacy */
    Layout[Layout["TextOnImageSmall"] = 8] = "TextOnImageSmall";
    /** @deprecated Legacy */
    Layout[Layout["TextOnImageMedium"] = 9] = "TextOnImageMedium";
})(Layout || (Layout = {}));
export var LayoutName;
(function (LayoutName) {
    LayoutName["CardSmall"] = "small";
    LayoutName["CardMedium"] = "medium";
    LayoutName["CardLarge"] = "large";
    LayoutName["CardProfile"] = "profile";
    LayoutName["FullPost"] = "full";
    LayoutName["SideBySide"] = "side-by-side";
    LayoutName["Grid"] = "grid";
    LayoutName["TextOnImageSmall"] = "text-on-image-small";
    LayoutName["TextOnImageMedium"] = "text-on-image-medium";
    LayoutName["PgTextOnImageSmall"] = "pg-text-on-image-small";
    LayoutName["PgTextOnImageMedium"] = "pg-text-on-image-medium";
    LayoutName["PgTextOnImageLarge"] = "pg-text-on-image-large";
    LayoutName["PgCardMedium"] = "pg-medium";
    LayoutName["PgSideBySide"] = "pg-side-by-side";
    LayoutName["PgSideBySideRight"] = "pg-side-by-side-right";
    LayoutName["PgGrid"] = "pg-grid";
    LayoutName["PgGridIntermediate"] = "pg-grid-intermediate";
    LayoutName["PgGridLarge"] = "pg-grid-large";
    LayoutName["PgOneColumn"] = "pg-one-column";
    LayoutName["Slider"] = "slider";
    LayoutName["List"] = "list";
    LayoutName["ListMedium"] = "list-medium";
    LayoutName["ListLarge"] = "list-large";
    // Mobile
    LayoutName["Mobile"] = "mobile";
    LayoutName["OneColumnMobile"] = "one-column-mobile";
    LayoutName["SideBySideMobile"] = "side-by-side-mobile";
    LayoutName["TextOnImageMobile"] = "text-on-image-mobile";
})(LayoutName || (LayoutName = {}));
export var LegacyLayout;
(function (LegacyLayout) {
    LegacyLayout[LegacyLayout["CardMedium"] = 1] = "CardMedium";
    LegacyLayout[LegacyLayout["SideBySide"] = 6] = "SideBySide";
    LegacyLayout[LegacyLayout["TextOnImageMedium"] = 9] = "TextOnImageMedium";
    LegacyLayout[LegacyLayout["Grid"] = 7] = "Grid";
    LegacyLayout[LegacyLayout["CardSmall"] = 0] = "CardSmall";
    LegacyLayout[LegacyLayout["TextOnImageSmall"] = 8] = "TextOnImageSmall";
    LegacyLayout[LegacyLayout["CardLarge"] = 2] = "CardLarge";
})(LegacyLayout || (LegacyLayout = {}));
export const SEO_LAYOUT_TYPE_FALLBACK = Layout.Grid;
export const LAYOUT_CARD_SMALL = Layout.CardSmall;
export const LAYOUT_CARD_MEDIUM = Layout.CardMedium;
export const LAYOUT_CARD_LARGE = Layout.CardLarge;
export const LAYOUT_CARD_PROFILE = Layout.CardProfile;
export const LAYOUT_FULL_POST = Layout.FullPost;
export const LAYOUT_MOBILE = Layout.Mobile;
export const LAYOUT_ONE_COLUMN_MOBILE = Layout.OneColumnMobile;
export const LAYOUT_SIDE_BY_SIDE_MOBILE = Layout.SideBySideMobile;
export const LAYOUT_TEXT_ON_IMAGE_MOBILE = Layout.TextOnImageMobile;
export const LAYOUT_PG_TEXT_ON_IMAGE_SMALL = Layout.PgTextOnImageSmall;
export const LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM = Layout.PgTextOnImageMedium;
export const LAYOUT_PG_TEXT_ON_IMAGE_LARGE = Layout.PgTextOnImageLarge;
export const LAYOUT_PG_CARD_MEDIUM = Layout.PgCardMedium;
export const LAYOUT_PG_SIDE_BY_SIDE = Layout.PgSideBySide;
export const LAYOUT_PG_SIDE_BY_SIDE_RIGHT = Layout.PgSideBySideRight;
export const LAYOUT_PG_GRID = Layout.PgGrid;
export const LAYOUT_PG_GRID_INTERMEDIATE = Layout.PgGridIntermediate;
export const LAYOUT_PG_GRID_LARGE = Layout.PgGridLarge;
export const LAYOUT_PG_ONE_COLUMN = Layout.PgOneColumn;
export const LAYOUT_SLIDER = Layout.Slider;
export const LAYOUT_LIST = Layout.List;
export const LAYOUT_LIST_MEDIUM = Layout.ListMedium;
export const LAYOUT_LIST_LARGE = Layout.ListLarge;
export const LAYOUT_SIDE_BY_SIDE = Layout.SideBySide;
export const LAYOUT_GRID = Layout.Grid;
export const LAYOUT_TEXT_ON_IMAGE_SMALL = Layout.TextOnImageSmall;
export const LAYOUT_TEXT_ON_IMAGE_MEDIUM = Layout.TextOnImageMedium;
export const LAYOUT_NAME_CARD_SMALL = LayoutName.CardSmall;
export const LAYOUT_NAME_CARD_MEDIUM = LayoutName.CardMedium;
export const LAYOUT_NAME_CARD_LARGE = LayoutName.CardLarge;
export const LAYOUT_NAME_CARD_PROFILE = LayoutName.CardProfile;
export const LAYOUT_NAME_FULL_POST = LayoutName.FullPost;
export const LAYOUT_NAME_MOBILE = LayoutName.Mobile;
export const LAYOUT_NAME_SIDE_BY_SIDE = LayoutName.SideBySide;
export const LAYOUT_NAME_GRID = LayoutName.Grid;
export const LAYOUT_NAME_TEXT_ON_IMAGE_SMALL = LayoutName.TextOnImageSmall;
export const LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM = LayoutName.TextOnImageMedium;
export const LAYOUT_NAME_ONE_COLUMN_MOBILE = LayoutName.OneColumnMobile;
export const LAYOUT_NAME_SIDE_BY_SIDE_MOBILE = LayoutName.SideBySideMobile;
export const LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE = LayoutName.TextOnImageMobile;
export const LAYOUT_NAME_PG_TEXT_ON_IMAGE_SMALL = LayoutName.PgTextOnImageSmall;
export const LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM = LayoutName.PgTextOnImageMedium;
export const LAYOUT_NAME_PG_TEXT_ON_IMAGE_LARGE = LayoutName.PgTextOnImageLarge;
export const LAYOUT_NAME_PG_CARD_MEDIUM = LayoutName.PgCardMedium;
export const LAYOUT_NAME_PG_SIDE_BY_SIDE = LayoutName.PgSideBySide;
export const LAYOUT_NAME_PG_SIDE_BY_SIDE_RIGHT = LayoutName.PgSideBySideRight;
export const LAYOUT_NAME_PG_GRID = LayoutName.PgGrid;
export const LAYOUT_NAME_PG_GRID_INTERMEDIATE = LayoutName.PgGridIntermediate;
export const LAYOUT_NAME_PG_GRID_LARGE = LayoutName.PgGridLarge;
export const LAYOUT_NAME_PG_ONE_COLUMN = LayoutName.PgOneColumn;
export const LAYOUT_NAME_SLIDER = LayoutName.Slider;
export const LAYOUT_NAME_LIST = LayoutName.List;
export const LAYOUT_NAME_LIST_MEDIUM = LayoutName.ListMedium;
export const LAYOUT_NAME_LIST_LARGE = LayoutName.ListLarge;
export const MOBILE_LAYOUT_NAMES = [
    LayoutName.Mobile,
    LayoutName.OneColumnMobile,
    LayoutName.SideBySideMobile,
    LayoutName.TextOnImageMobile,
];
export const FEED_LAYOUT_TYPES = {
    [Layout.CardSmall]: LayoutName.CardSmall,
    [Layout.CardMedium]: LayoutName.CardMedium,
    [Layout.CardLarge]: LayoutName.CardLarge,
    [Layout.FullPost]: LayoutName.FullPost,
    [Layout.SideBySide]: LayoutName.SideBySide,
    [Layout.Grid]: LayoutName.Grid,
    [Layout.TextOnImageSmall]: LayoutName.TextOnImageSmall,
    [Layout.TextOnImageMedium]: LayoutName.TextOnImageMedium,
    [Layout.TextOnImageMobile]: LayoutName.TextOnImageMobile,
    [Layout.PgTextOnImageSmall]: LayoutName.PgTextOnImageSmall,
    [Layout.PgTextOnImageMedium]: LayoutName.PgTextOnImageMedium,
    [Layout.PgTextOnImageLarge]: LayoutName.PgTextOnImageLarge,
    [Layout.PgCardMedium]: LayoutName.PgCardMedium,
    [Layout.PgSideBySide]: LayoutName.PgSideBySide,
    [Layout.PgSideBySideRight]: LayoutName.PgSideBySideRight,
    [Layout.PgGrid]: LayoutName.PgGrid,
    [Layout.PgGridIntermediate]: LayoutName.PgGridIntermediate,
    [Layout.PgGridLarge]: LayoutName.PgGridLarge,
    [Layout.PgOneColumn]: LayoutName.PgOneColumn,
    [Layout.List]: LayoutName.List,
    [Layout.ListMedium]: LayoutName.ListMedium,
    [Layout.ListLarge]: LayoutName.ListLarge,
    [Layout.Slider]: LayoutName.Slider,
};
export const POST_LIST_LAYOUT_TYPES = {
    [Layout.PgGrid]: LayoutName.PgGrid,
    [Layout.PgGridLarge]: LayoutName.PgGridLarge,
    [Layout.Slider]: LayoutName.Slider,
    [Layout.ListMedium]: LayoutName.ListMedium,
    [Layout.ListLarge]: LayoutName.ListLarge,
    [Layout.PgSideBySide]: LayoutName.PgSideBySide,
    [Layout.PgSideBySideRight]: LayoutName.PgSideBySideRight,
    [Layout.PgOneColumn]: LayoutName.PgOneColumn,
    [Layout.PgTextOnImageSmall]: LayoutName.PgTextOnImageSmall,
    [Layout.PgTextOnImageMedium]: LayoutName.PgTextOnImageMedium,
    [Layout.PgTextOnImageLarge]: LayoutName.PgTextOnImageLarge,
    [Layout.PgGridIntermediate]: LayoutName.PgGridIntermediate,
    [Layout.List]: LayoutName.List,
    [Layout.PgCardMedium]: LayoutName.PgCardMedium,
};
export const RELATED_POSTS_LAYOUT_TYPES = {
    [Layout.PgGrid]: LayoutName.PgGrid,
    [Layout.PgGridLarge]: LayoutName.PgGridLarge,
    [Layout.Slider]: LayoutName.Slider,
    [Layout.ListMedium]: LayoutName.ListMedium,
    [Layout.ListLarge]: LayoutName.ListLarge,
    [Layout.PgSideBySide]: LayoutName.PgSideBySide,
    [Layout.PgSideBySideRight]: LayoutName.PgSideBySideRight,
    [Layout.PgOneColumn]: LayoutName.PgOneColumn,
    [Layout.PgTextOnImageSmall]: LayoutName.PgTextOnImageSmall,
    [Layout.PgTextOnImageMedium]: LayoutName.PgTextOnImageMedium,
    [Layout.PgTextOnImageLarge]: LayoutName.PgTextOnImageLarge,
    [Layout.PgGridIntermediate]: LayoutName.PgGridIntermediate,
    [Layout.List]: LayoutName.List,
    [Layout.PgCardMedium]: LayoutName.PgCardMedium,
};
export const DESKTOP_LAYOUT_TYPES_TO_MOBILE = {
    [Layout.PgGrid]: Layout.PgGrid,
    [Layout.PgGridIntermediate]: Layout.PgGrid,
    [Layout.PgGridLarge]: Layout.PgGrid,
    [Layout.Slider]: Layout.Slider,
    [Layout.List]: Layout.List,
    [Layout.ListMedium]: Layout.List,
    [Layout.ListLarge]: Layout.List,
    [Layout.PgSideBySide]: Layout.PgGrid,
    [Layout.PgSideBySideRight]: Layout.PgGrid,
    [Layout.PgTextOnImageMedium]: Layout.PgTextOnImageMedium,
    [Layout.PgTextOnImageSmall]: Layout.PgTextOnImageMedium,
    [Layout.PgTextOnImageLarge]: Layout.PgTextOnImageMedium,
    [Layout.PgOneColumn]: Layout.PgGrid,
    [Layout.PgCardMedium]: Layout.PgGrid,
};
export const MY_POSTS_LAYOUT_TYPES = {
    [Layout.PgSideBySide]: LayoutName.PgSideBySide,
};
export const LAYOUT_TYPES = Object.assign(Object.assign(Object.assign(Object.assign({}, FEED_LAYOUT_TYPES), POST_LIST_LAYOUT_TYPES), RELATED_POSTS_LAYOUT_TYPES), MY_POSTS_LAYOUT_TYPES);
export const LAYOUT_TYPES_BY_SECTION = {
    [SECTION_HOMEPAGE]: FEED_LAYOUT_TYPES,
    [SECTION_CATEGORY]: FEED_LAYOUT_TYPES,
    [SECTION_POST_LIST]: POST_LIST_LAYOUT_TYPES,
    [SECTION_RELATED_POSTS]: RELATED_POSTS_LAYOUT_TYPES,
    [SECTION_MY_POSTS]: MY_POSTS_LAYOUT_TYPES,
};
export const LAYOUT_TYPES_MOBILE = {
    [Layout.OneColumnMobile]: LayoutName.OneColumnMobile,
    [Layout.SideBySideMobile]: LayoutName.SideBySideMobile,
    [Layout.TextOnImageMobile]: LayoutName.TextOnImageMobile,
};
export const OTHER_LAYOUT_TYPES = {
    [Layout.CardProfile]: LayoutName.CardProfile,
    [Layout.Mobile]: LayoutName.Mobile,
};
export const PG_LAYOUTS_WITH_CONTENT_HEIGHT = [
    Layout.PgGrid,
    Layout.PgGridIntermediate,
    Layout.PgGridLarge,
    Layout.PgCardMedium,
    Layout.PgOneColumn,
    Layout.Slider,
    Layout.List,
    Layout.ListMedium,
    Layout.ListLarge,
];
export var SideBySideLayout;
(function (SideBySideLayout) {
    SideBySideLayout[SideBySideLayout["ImageLeft"] = 0] = "ImageLeft";
    SideBySideLayout[SideBySideLayout["ImageRight"] = 1] = "ImageRight";
    SideBySideLayout[SideBySideLayout["ImageNone"] = 2] = "ImageNone";
})(SideBySideLayout || (SideBySideLayout = {}));
export function getPGMappedLayout(layoutType) {
    const legacyLayoutMap = {
        [LegacyLayout.CardMedium]: Layout.PgCardMedium,
        [LegacyLayout.SideBySide]: Layout.PgSideBySide,
        [LegacyLayout.TextOnImageMedium]: Layout.PgTextOnImageMedium,
        [LegacyLayout.Grid]: Layout.PgGrid,
        [LegacyLayout.CardSmall]: Layout.PgCardMedium,
        [LegacyLayout.TextOnImageSmall]: Layout.PgTextOnImageMedium,
        [LegacyLayout.CardLarge]: Layout.PgGrid, // one col
    };
    if (isLayoutOneColumn(layoutType)) {
        return Layout.PgOneColumn;
    }
    if (isOldLayout(layoutType)) {
        return legacyLayoutMap[layoutType];
    }
    return layoutType;
    function isOldLayout(unknownLayout) {
        return unknownLayout in legacyLayoutMap;
    }
}
export function getLayoutNameById(layoutId) {
    const layoutNamesMap = {
        [Layout.CardSmall]: 'Brick',
        [Layout.CardMedium]: 'Tiled',
        [Layout.CardLarge]: 'One column',
        [Layout.FullPost]: 'Full post',
        [Layout.SideBySide]: 'Side by side',
        [Layout.Grid]: 'Editorial',
        [Layout.TextOnImageSmall]: 'Postcard',
        [Layout.TextOnImageMedium]: 'Magazine',
        [Layout.OneColumnMobile]: 'Mobile One Column',
        [Layout.SideBySideMobile]: 'Mobile Side By Side',
        [Layout.TextOnImageMobile]: 'Mobile Magazine',
        [Layout.PgTextOnImageSmall]: 'Magazine Pro Gallery (small)',
        [Layout.PgTextOnImageMedium]: 'Magazine Pro Gallery',
        [Layout.PgTextOnImageLarge]: 'Magazine Pro Gallery (large)',
        [Layout.PgCardMedium]: 'Tiled Pro Gallery',
        [Layout.PgSideBySide]: 'Side by side Pro Gallery',
        [Layout.PgSideBySideRight]: 'Side by side (right) Pro Gallery',
        [Layout.PgGrid]: 'Editorial Pro Gallery',
        [Layout.PgGridIntermediate]: 'Editorial Pro Gallery (medium)',
        [Layout.PgGridLarge]: 'Editorial Pro Gallery (large)',
        [Layout.PgOneColumn]: 'One column Pro Gallery',
        [Layout.Slider]: 'Slider',
        [Layout.List]: 'List',
        [Layout.ListMedium]: 'List Medium',
        [Layout.ListLarge]: 'List Large',
    };
    return layoutNamesMap[layoutId];
}
export function getLayoutPaginationTypeNameById(typeId) {
    const paginationTypeMap = {
        [PaginationType.InfiniteScroll]: 'On scroll down',
        [PaginationType.MultiplePages]: 'With page numbers',
    };
    return paginationTypeMap[typeId];
}
export function getLayoutTypeById(layoutId) {
    return layoutId ? LAYOUT_TYPES[layoutId] : undefined;
}
export const getLayoutName = (layoutType) => LAYOUT_TYPES[layoutType] ||
    LAYOUT_TYPES_MOBILE[layoutType] ||
    OTHER_LAYOUT_TYPES[layoutType];
export const isLayoutProGallery = (layoutType) => [
    Layout.PgTextOnImageSmall,
    Layout.PgTextOnImageMedium,
    Layout.PgTextOnImageLarge,
    Layout.PgCardMedium,
    Layout.PgSideBySide,
    Layout.PgSideBySideRight,
    Layout.PgGrid,
    Layout.PgGridIntermediate,
    Layout.PgGridLarge,
    Layout.PgOneColumn,
    Layout.List,
    Layout.ListMedium,
    Layout.ListLarge,
    Layout.Slider,
].includes(Number(layoutType));
export const isPGLayoutWithDescription = (layoutType) => [
    Layout.PgCardMedium,
    Layout.PgSideBySide,
    Layout.PgSideBySideRight,
    Layout.PgGrid,
    Layout.PgGridIntermediate,
    Layout.PgGridLarge,
    Layout.PgOneColumn,
    Layout.Slider,
].includes(Number(layoutType));
export const isLayoutNameOneOfProGallery = (layoutName) => [
    LayoutName.PgTextOnImageSmall,
    LayoutName.PgTextOnImageMedium,
    LayoutName.PgTextOnImageLarge,
    LayoutName.PgCardMedium,
    LayoutName.PgSideBySide,
    LayoutName.PgSideBySideRight,
    LayoutName.PgGrid,
    LayoutName.PgOneColumn,
].includes(layoutName);
const isLayoutOneColumn = (layoutType) => Number(layoutType) === Layout.CardLarge;
export const isLayoutPGOneColumn = (layoutType) => Number(layoutType) === Layout.PgOneColumn;
export const isLayoutPGGrid = (layoutType) => Number(layoutType) === Layout.PgGrid ||
    Number(layoutType) === Layout.PgGridIntermediate ||
    Number(layoutType) === Layout.PgGridLarge;
export const isLayoutPGSideBySide = (layoutType) => Number(layoutType) === Layout.PgSideBySide ||
    Number(layoutType) === Layout.PgSideBySideRight;
export const isLayoutPGCardMedium = (layoutType) => Number(layoutType) === Layout.PgCardMedium;
export const isLayoutPGCard = (layoutType) => Number(layoutType) === Layout.PgCardMedium;
export const isLayoutPGWithContentHeight = (layoutType) => includes(PG_LAYOUTS_WITH_CONTENT_HEIGHT, Number(layoutType));
export const isLayoutGrid = (layoutType) => Number(layoutType) === Layout.Grid;
export const isLayoutFullPost = (layoutType) => Number(layoutType) === Layout.FullPost;
export const isLayoutTextOnImage = (layoutType) => includes([
    Layout.TextOnImageSmall,
    Layout.TextOnImageMedium,
    Layout.TextOnImageMobile,
    Layout.PgTextOnImageSmall,
    Layout.PgTextOnImageMedium,
    Layout.PgTextOnImageLarge,
], Number(layoutType));
export const isLayoutSlider = (layoutType) => Number(layoutType) === Layout.Slider;
export const isLayoutList = (layoutType) => Number(layoutType) === Layout.List ||
    Number(layoutType) === Layout.ListMedium ||
    Number(layoutType) === Layout.ListLarge;
export const isLayoutMobile = (layoutType) => includes([
    Layout.Mobile,
    Layout.OneColumnMobile,
    Layout.SideBySideMobile,
    Layout.TextOnImageMobile,
], Number(layoutType));
export const isLayoutNameMobile = (layoutName) => includes(MOBILE_LAYOUT_NAMES, layoutName);
export const isLayoutNamePGSideBySide = (layoutName) => includes([LayoutName.PgSideBySide, LayoutName.PgSideBySideRight], layoutName);
export const isLayoutNamePGOneColumn = (layoutName) => layoutName === LayoutName.PgOneColumn;
export const isLayoutNameGrid = (layoutName) => layoutName === LayoutName.Grid;
export const isLayoutNameSlider = (layoutName) => layoutName === LayoutName.Slider;
export const isLayoutNameList = (layoutName) => includes([LayoutName.List, LayoutName.ListMedium, LayoutName.ListLarge], layoutName);
export const isLayoutNameTextOnImage = (layoutName) => includes([
    LayoutName.TextOnImageSmall,
    LayoutName.TextOnImageMedium,
    LayoutName.TextOnImageMobile,
    LayoutName.PgTextOnImageSmall,
    LayoutName.PgTextOnImageMedium,
    LayoutName.PgTextOnImageLarge,
], layoutName);
export function isMultiplePagesSupported(layoutType) {
    const layoutsWithPagesSupport = [
        Layout.CardLarge,
        Layout.FullPost,
        Layout.Grid,
        Layout.PgGridIntermediate,
        Layout.PgGridLarge,
        Layout.Mobile,
        Layout.SideBySide,
        Layout.TextOnImageMedium,
        Layout.TextOnImageSmall,
        Layout.OneColumnMobile,
        Layout.SideBySideMobile,
        Layout.TextOnImageMobile,
        Layout.PgTextOnImageSmall,
        Layout.PgTextOnImageMedium,
        Layout.PgTextOnImageLarge,
        Layout.PgSideBySide,
        Layout.PgSideBySideRight,
        Layout.PgGrid,
        Layout.PgOneColumn,
        Layout.List,
        Layout.ListMedium,
        Layout.ListLarge,
    ];
    return layoutsWithPagesSupport.includes(layoutType);
}
export const isAuthorImageSupported = (layoutId) => {
    if ([
        Layout.TextOnImageSmall,
        Layout.TextOnImageMedium,
        Layout.PgTextOnImageSmall,
        Layout.PgTextOnImageMedium,
        Layout.PgTextOnImageLarge,
    ].includes(layoutId)) {
        return false;
    }
    return true;
};
//# sourceMappingURL=layout-types.js.map